import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tagStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { BodySBold } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ITag {
	text: string;
	color: types.theme.badgeColor |string;
	marginLeft?: number;
	marginRight?: number;
}

const Tag = ({ text, color, marginLeft, marginRight }: ITag) => {
	const classes = useStyles({ marginLeft, marginRight });
	return (
		<div className={classNames(classes[`${color}Tag`], classes.tag)}>
			<BodySBold disableMargin>{text}</BodySBold>
		</div>
	);
};

export default Tag;
